export class ENDPOINT_URL{
    public static readonly LIST_USA_STATES :string = 'ListUsaStates'
}